import React from "react";
import WcaRow from "./WcaRow";

function WcaTable({ wca = [], onEdit }) {
  console.log("----------WcaTable function LOADED");

  return (
   <div style={{ marginBottom: "8px" }}>
      <div
        style={{
          marginBottom: "10px",
          fontSize: "18px",
          fontWeight: "bold",
          color: "#333",
        }}
      >
        <div>
          Note: wind decoding is automatically calculated. See example below:
        </div>
        <div>
          810543: 81-50=31 &rarr; 310°; 05: 100+05=105kts; 43: -43°C
        </div>
        <br />
        <div>Note: rotate phone to view the tables below and scroll table left/right</div>
      </div>
         
      

      {/* Nav Log Table */}
      <table
        id="navlogx">
          <caption 
            style={{
              captionSide: "top", 
              fontSize: "26px", 
              fontWeight: "bold", 
              color: "#090909",
              textAlign: "left",
              marginBottom: "6px",
              //backgroundColor: "antiquewhite",
              
              }}>
            Wind Correction Angle, True Heading, Headwind, Crosswind
            </caption>
        <thead>
          <tr>
            <th className="navlog-ft-col">FT</th>

            <th className="navlog-cruisealt-col">CruiseAlt</th>
            <th className="navlog-cas-col">CAS (kts.)</th>
            <th className="navlog-tc-col">TC°</th>


            <th className="navlog-tas-col">TAS (kts.)</th>
            <th className="navlog-wind-col">Wind interp.</th>

            <th className="navlog-wca-col">WCA°</th>
            <th className="navlog-th-col">TH°</th>

            <th className="navlog-hw-col">HW/TW</th>
            <th className="navlog-cw-col">CW (kts.)</th>

          </tr>
        </thead>

        <tbody>
          {wca.map((leg, i) => (
            <WcaRow
              key={i}
              plan={leg}
              index={i}
              onEdit={onEdit}
              
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default WcaTable;